import React from 'react';
import { socialIconMap } from '../../features/footer/socialLinks';

const FooterSocialDock = ({ socialLinks = [] }) => {
  const activeLinks = (Array.isArray(socialLinks) ? socialLinks : [])
    .filter((item) => item?.isActive !== false)
    .sort((a, b) => (Number(a.sortOrder) || 0) - (Number(b.sortOrder) || 0));

  if (!activeLinks.length) return null;

  return (
    <div className="mt-8">
      <p className="mb-4 text-xs font-semibold uppercase tracking-[0.28em] text-pearl-200/70">
        Connect with Pearl Voyages
      </p>

      <div className="flex flex-wrap items-center gap-3">
        {activeLinks.map((item) => {
          const Icon = socialIconMap[item.platform];

          if (!Icon) return null;

          return (
            <a
              key={`${item.platform}-${item.url}`}
              href={item.url}
              target={item.openInNewTab === false ? undefined : '_blank'}
              rel={item.openInNewTab === false ? undefined : 'noopener noreferrer'}
              aria-label={item.label}
              className="group relative flex h-12 w-12 items-center justify-center overflow-hidden rounded-full border border-white/10 bg-white/[0.045] text-pearl-100 shadow-[0_14px_40px_rgba(0,0,0,0.22)] backdrop-blur-md transition-all duration-300 hover:-translate-y-1 hover:border-gold-300/70 hover:bg-gold-300/10 hover:text-gold-200"
            >
              <span className="absolute inset-0 rounded-full bg-gradient-to-br from-white/15 via-transparent to-gold-300/15 opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
              <Icon className="relative z-10 h-5 w-5 transition-transform duration-300 group-hover:scale-110" />
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default FooterSocialDock;
